var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTradingInstrumentForex(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 89,
    viewBox: "0 0 88 89",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 88,
    height: 89,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.1322 22.3813H43.8662V11.0547H48.1322V22.3813ZM46.708 12.4722H45.3242V20.9638H46.7417L46.708 12.4722Z",
    fill: "#111733"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.1322 63.4757H43.8662V52.149H48.1322V63.4757ZM46.708 53.5397H45.3242V62.038H46.7417L46.708 53.5397Z",
    fill: "#111733"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.825 69.1186H19V36.5428H31.825V69.1186ZM30.3805 37.9604H20.4242V67.7011H30.3805V37.9604Z",
    fill: "#111733"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5384 37.9605H23.2656V26.6339H27.5384V37.9605ZM26.1141 28.0514H24.6899V36.543H26.1141V28.0514Z",
    fill: "#111733"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5384 79.0548H23.2656V67.7281H27.5384V79.0548ZM26.1141 69.1188H24.6899V77.6373H26.1141V69.1188Z",
    fill: "#111733"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M52.407 53.5396H39.582V20.9639H52.407V53.5396ZM50.9828 22.3814H41.0198V52.1087H50.9828V22.3814Z",
    fill: "#057EE6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M72.9998 69.1186H60.1748V36.5428H72.9998V69.1186ZM71.5756 37.9604H61.6193V67.7011H71.5756V37.9604Z",
    fill: "#111733"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M68.7337 37.9605H64.4609V26.6339H68.7337V37.9605ZM67.3094 28.0514H65.8852V36.543H67.3094V28.0514Z",
    fill: "#111733"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M68.7337 79.0548H64.4609V67.7281H68.7337V79.0548ZM67.3094 69.1188H65.8852V77.6373H67.3094V69.1188Z",
    fill: "#111733"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTradingInstrumentForex);
export default __webpack_public_path__ + "static/media/trading-instrument-forex.2fdcfac291b02132a4569e422f087c7e.svg";
export { ForwardRef as ReactComponent };